// Init Leaflet map sur les pages /projets/ et /realisations/
// Lit les markers depuis data-markers="[{lat,lng,title,url,status},…]"
// Centre par défaut sur Bruxelles, zoom auto pour englober tous les markers.
var escapeHtml = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
        return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]);
    });
};
var initProjectsMap = function () {
    var canvas = document.getElementById("projects-map-canvas");
    if (!canvas)
        return;
    if (canvas.classList.contains("leaflet-container"))
        return; // déjà initialisé
    if (typeof L === "undefined") {
        // Leaflet pas encore chargé — re-tente dans 100ms (max ~5s)
        var attempts_1 = 0;
        var retry_1 = setInterval(function () {
            attempts_1++;
            if (typeof L !== "undefined") {
                clearInterval(retry_1);
                initProjectsMap();
            }
            else if (attempts_1 > 50) {
                clearInterval(retry_1);
                console.warn("[projects-map] Leaflet non chargé après 5s — abandon");
            }
        }, 100);
        return;
    }
    var markers = [];
    try {
        markers = JSON.parse(canvas.getAttribute("data-markers") || "[]");
    }
    catch (e) {
        console.warn("[projects-map] data-markers invalide", e);
    }
    // Centre Bruxelles par défaut
    var map = L.map(canvas, { scrollWheelZoom: false }).setView([50.8503, 4.3517], 8);
    // CartoDB Positron — style minimaliste gris/blanc, markers ressortent
    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
        maxZoom: 19,
        subdomains: "abcd",
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
    }).addTo(map);
    if (markers.length === 0)
        return;
    // Icône custom — pin minimaliste rouge dans la charte e-maprod
    var redIcon = L.divIcon({
        className: "projects-map__marker",
        html: '<span class="projects-map__marker-dot"></span>',
        iconSize: [16, 16],
        iconAnchor: [8, 8]
    });
    var latLngs = [];
    markers.forEach(function (m) {
        var lat = parseFloat(String(m.lat));
        var lng = parseFloat(String(m.lng));
        if (!isFinite(lat) || !isFinite(lng))
            return;
        var title = escapeHtml(m.title || "");
        var url = escapeHtml(m.url || "#");
        var status = m.status ? escapeHtml(m.status) : "";
        var commune = m.commune ? escapeHtml(m.commune) : "";
        var excerpt = m.excerpt ? escapeHtml(m.excerpt) : "";
        var photo = m.photo ? escapeHtml(m.photo) : "";
        var popupHtml = "\n      <a class=\"projects-map__popup\" href=\"" + url + "\">\n        " + (photo
            ? "<div class=\"projects-map__popup-media\" style=\"background-image:url('" + photo + "');\"></div>"
            : "<div class=\"projects-map__popup-media projects-map__popup-media--placeholder\"></div>") + "\n        <div class=\"projects-map__popup-body\">\n          " + ((status || commune)
            ? "<div class=\"projects-map__popup-meta\">\n                 " + (status ? "<span class=\"projects-map__popup-status\">" + status + "</span>" : "") + "\n                 " + ((status && commune) ? "<span class=\"projects-map__popup-sep\">\u00B7</span>" : "") + "\n                 " + (commune ? "<span class=\"projects-map__popup-commune\">" + commune + "</span>" : "") + "\n               </div>"
            : "") + "\n          <div class=\"projects-map__popup-title\">" + title + "</div>\n          " + (excerpt ? "<div class=\"projects-map__popup-excerpt\">" + excerpt + "</div>" : "") + "\n          <div class=\"projects-map__popup-cta\">Voir le projet \u2192</div>\n        </div>\n      </a>\n    ";
        L.marker([lat, lng], { icon: redIcon })
            .addTo(map)
            .bindPopup(popupHtml, {
            className: "projects-map__popup-wrapper",
            maxWidth: 280,
            minWidth: 260,
            closeButton: true,
            autoPan: true
        });
        latLngs.push([lat, lng]);
    });
    if (latLngs.length > 0) {
        map.fitBounds(latLngs, { padding: [40, 40], maxZoom: 13 });
    }
};
// Robust : exécute immédiatement si le DOM est déjà prêt (cas async/defer),
// sinon attache l'écouteur classique.
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProjectsMap);
}
else {
    initProjectsMap();
}
